import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@common/components';
function SearchPolicyCardSkeleton() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex h-48 items-start justify-between mobile-tablet:h-auto"><Skeleton className="h-24 w-3/4 rounded-xxsmall" /><Skeleton className="size-24 shrink-0 rounded-xxsmall mobile-tablet:hidden" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="rounded-small bg-Gray-25 p-12"><div className="flex flex-col gap-4"><Skeleton className="h-16 w-full rounded-xxsmall" /><Skeleton className="h-16 w-5/6 rounded-xxsmall" /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div role="status" aria-label={"\uC815\uCC45 \uCE74\uB4DC \uB85C\uB529 \uC911"} className="flex flex-col gap-8 overflow-hidden rounded-medium border border-Gray-100 bg-Gray-white px-24 py-20 mobile-tablet:rounded-none mobile-tablet:border-x-0 mobile-tablet:border-b-0 mobile-tablet:border-t mobile-tablet:first:border-t-0">{t0}{t1}<div className="flex items-center justify-between gap-12"><Skeleton typo="caption1" className="w-160 rounded-xxsmall" /><Skeleton className="h-20 w-100 rounded-xxsmall" /></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
interface SearchPolicyCardSkeletonListProps {
  count: number;
}
export function SearchPolicyCardSkeletonList(t0) {
  const $ = _c(2);
  const {
    count
  } = t0;
  let t1;
  if ($[0] !== count) {
    t1 = <ul aria-busy="true" className="flex flex-col gap-12 mobile-tablet:gap-0">{Array.from({
        length: count
      }, _temp)}</ul>;
    $[0] = count;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp(_, index) {
  return <li key={index}><SearchPolicyCardSkeleton /></li>;
}